
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';
import IconLink from '@components/icons/icon-link.svg';

@Component({
  name: 'TripMergeButton',
  components: {
    IconLink
  }
})
export default class TripMergeButton extends Vue {
  @Prop({ default: false })
  private disabled: boolean

  private mergeText = 'Wollen Sie die beiden Fahrten wirklich zusammenführen? Diese Aktion kann nicht rückgängig gemacht werden.';

  private onMergeButton() {
    if (window.confirm(this.mergeText)) {
      this.$emit('merge');
    }
  }
}
